import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ThankYou: React.FC = () => {
  // Add 'dark' class to the root element for dark mode consistency
  React.useEffect(() => {
    document.documentElement.classList.add('dark');
    return () => {
      // Optionally remove dark mode when component unmounts if needed elsewhere
      // document.documentElement.classList.remove('dark');
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 px-4">
      <div className="bg-white dark:bg-gray-800 p-10 rounded-2xl shadow-xl text-center max-w-md w-full">
        <CheckCircle className="text-green-500 w-16 h-16 mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Thank You!</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Your message has been sent successfully. We'll get back to you shortly.
        </p>
        <Link
          to="/"
          className="inline-block bg-sky-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-sky-700 transition-colors transform hover:scale-105 transition-transform"
        >
          Return to Home
        </Link>
      </div>
      <footer className="mt-12 text-center text-gray-500 dark:text-gray-400">
        <p>&copy; {new Date().getFullYear()} SprynAI LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ThankYou;
